import React, { useState } from 'react';

import { Box, TextField, Autocomplete } from '@mui/material';
import { useMetadata } from '../../../../providers/MetadataContext';

function DealInvestmentStrategyField({ value, setValue }) {
  const metadata = useMetadata();
  const [selected, setSelected] = useState(
    (metadata?.deal?.lists?.investment_strategies || []).find(
      (option) => option.entity_id === value
    )
  );

  const handleChange = (event, newValue) => {
    setSelected(newValue);
    setValue(newValue.entity_id);
  };

  return (
    <Box>
      <Autocomplete
        id='investment-strategy-field'
        options={metadata?.deal?.lists?.investment_strategies || []}
        value={selected}
        onChange={handleChange}
        getOptionLabel={(option) => `${option.name}`}
        renderInput={(params) => (
          <TextField {...params} label='Investment Strategy' />
        )}
      />
    </Box>
  );
}

export default DealInvestmentStrategyField;
